import { useState, useEffect } from 'react';
import { useAuthStore } from '../stores/useAuthStore';
import { MODAL_TIMEOUT_ID } from '../constants/authConstants';
import { showModal } from '../components/EpModal';

const useUserActivity = () => {
  const { setOpenModalTimeout, isActivity, setIsActivity } = useAuthStore();

  // ? Retirar comentários da linha 12 até 19
  // ? caso queira calcular dinamicamente o tempo máximo de inatividade do usuário
  // const user = useSelector(state => state.auth.user);
  // const [identityAcessTokenExpiringTime, setIdentityAcessTokenExpiringTime] = useState(null);

  // useEffect(() => {
  //   if (user) {
  //     setIdentityAcessTokenExpiringTime(user.expire);
  //   }
  // }, [user]);

  const [isActive, setIsActive] = useState(isActivity);
  let secondsSinceLastActivity = 0;

  // ? Retirar comentários da linha 26 até 27
  // ? caso queira calcular dinamicamente o tempo máximo de inatividade do usuário
  // eslint-disable-next-line max-len
  // const maxInactivity = identityAcessTokenExpiringTime ? identityAcessTokenExpiringTime - IDENTITY_ACCESS_TOKEN_EXPIRING_NOTIFICATION_TIME : 60 * 5;
  const maxInactivity = 60 * 18; // 20 minutos

  // A cada segundo checa se o usuário está inativo
  // e se ele estiver muda o state para false
  setInterval(() => {
    secondsSinceLastActivity += 1;
    if (secondsSinceLastActivity > maxInactivity) {
      setIsActive(false);
      setIsActivity(false);
    };
  }, 1000);

  // Reseta o contador e muda o state para true
  const activity = () => {
    secondsSinceLastActivity = 0;
  };

  // Lista de events que contam como atividade
  const activityEvents = [
    'mousedown', 'mousemove', 'keydown',
    'scroll', 'touchstart',
  ];

  // Adiciona listeners para os eventes e chama o metodo
  // activity caso um deles ocorra
  activityEvents.forEach((eventName) => {
    if (typeof document === 'undefined') return;
    document.addEventListener(eventName, activity, true);
  });

  useEffect(() => {
    if (!isActive) {
      setOpenModalTimeout(true);
      showModal(MODAL_TIMEOUT_ID);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isActive]);

  return isActive;
};

export default useUserActivity;
